import React from 'react';
import { BookOpen, MousePointerClick, Heart } from 'lucide-react';
export function HowItWorks() {
  return <section className="py-8 px-4 bg-purple-50/40" data-id="element-99">
      <div className="max-w-4xl mx-auto text-center" data-id="element-100">
        <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-101">
          📖 ¿Cómo funciona?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-102">
          <div className="flex flex-col items-center" data-id="element-103">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mb-2" data-id="element-104">
              <BookOpen className="w-7 h-7 text-purple-600" data-id="element-105" />
            </div>
            <h3 className="text-xl font-bold mb-1" data-id="element-106">1. Abrís el pack</h3>
            <p className="text-gray-600" data-id="element-107">
              Acceso digital inmediato desde cualquier dispositivo.
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-108">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mb-2" data-id="element-109">
              <MousePointerClick className="w-7 h-7 text-purple-600" data-id="element-110" />
            </div>
            <h3 className="text-xl font-bold mb-1" data-id="element-111">2. Elegís un momento</h3>
            <p className="text-gray-600" data-id="element-112">
              Actividades simples que se adaptan a tu tiempo.
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-113">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mb-2" data-id="element-114">
              <Heart className="w-7 h-7 text-purple-600" data-id="element-115" />
            </div>
            <h3 className="text-xl font-bold mb-1" data-id="element-116">3. Vivís la experiencia</h3>
            <p className="text-gray-600" data-id="element-117">
              Conectás, reís y creás un recuerdo real.
            </p>
          </div>
        </div>

        <div className="mt-6 p-3 bg-white/70 rounded-lg inline-block" data-id="element-118">
          <p className="text-lg font-medium text-gray-800" data-id="element-119">
            Sin planificar. Sin improvisar. Sin sentir que "no sabés cómo".
          </p>
        </div>
      </div>
    </section>;
}